import React from "react";
import "../../Styles/yellowcalf.css/Transportation_Details.css";

function Transportation_Details() {
  return (
    <div className="transportation-details-container" style={{paddingTop:"25px"}}>
      {/* Header Panel */}
      <div className="transportation-details-row">
        <div className="transportation-details-col">
          <div className="transportation-details-panel">
            <div className="transportation-details-panel-body">
              <div className="transportation-details-header">
                <h3 className="transportation-details-title">Transportation Details</h3>

                <div className="transportation-details-export-group">
                  <button
                    data-toggle="dropdown"
                    className="transportation-details-export-btn"
                  >
                    Export <i className="fa fa-angle-down"></i>
                  </button>

                  <ul className="transportation-details-dropdown-menu">
                    <li>
                      <a
                        href="#"
                        className="transportation-details-export-pdf"
                        data-table="#billingreport"
                      >
                        Save as PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filters and Report Section */}
      <div className="transportation-details-row">
        <div className="transportation-details-col">
          <div className="transportation-details-filter-panel">
            <div
              className="transportation-details-filter-header"
              style={{ display: "block", minHeight: "35px" }}
            >
              <div className="transportation-details-panel-tools"></div>
              <div id="status-alert"></div>
            </div>

            <div className="transportation-details-filter-body">
              <div className="transportation-details-filters">
                <div className="transportation-details-filter-section" align="center">
                  <div className="transportation-details-row">
                    {/* Student Select */}
                    <div className="transportation-details-col-lg">
                      <select
                        id="student_id"
                        className="transportation-details-select"
                        name="student"
                      >
                        <option value="">Select Student</option>
                        <option value="256">anju - 3567643</option>
                        <option value="270">ansh - 827714</option>
                        <option value="272">ansh - 827714</option>
                        <option value="268">ansh - 958884</option>
                        <option value="274">ansh - 827714</option>
                        <option value="275">ansh - 827714</option>
                        <option value="271">ansh - 827714</option>
                      </select>
                    </div>

                    {/* Grade Select */}
                    <div className="transportation-details-col-lg">
                      <select
                        id="class_id"
                        className="transportation-details-select"
                        name="student_class"
                      >
                        <option value="">Select Grade</option>
                        <option value="1">KG1 A</option>
                        <option value="56">NURSERY 1 A</option>
                        <option value="59">10th A</option>
                        <option value="30">XII A</option>
                        <option value="38">1st A</option>
                        <option value="83">6 A</option>
                        <option value="95">GRADE 10 A</option>
                        <option value="149">New Invoice A</option>
                      </select>
                    </div>

                    {/* Parent Select */}
                    <div className="transportation-details-col-lg">
                      <select
                        id="parent_id"
                        className="transportation-details-select"
                        name="parent"
                      >
                        <option value="">Select Parent</option>
                        <option value="16122">23422</option>
                        <option value="16642">achan</option>
                        <option value="55181">akbar</option>
                        <option value="33913">alex</option>
                        <option value="42997">Amal</option>
                        <option value="15938">amit</option>
                        <option value="55538">tvm</option>
                      </select>
                    </div>

                    {/* Trip Type */}
                    <div className="transportation-details-col-lg">
                      <select
                        id="trip_type"
                        name="trip_type"
                        className="transportation-details-select"
                      >
                        <option value="">Select Trip Type</option>
                        <option value="pickup">Pickup</option>
                        <option value="drop">Drop</option>
                        <option value="both">Both</option>
                      </select>
                    </div>

                    {/* Trip Select */}
                    <div className="transportation-details-col-lg">
                      <select
                        id="trip_id"
                        className="transportation-details-select"
                        name="trip"
                      >
                        <option value="">Select Trip</option>
                        <option value="256">16_06_1_a</option>
                        <option value="255">bial</option>
                        <option value="88">Drop Trip</option>
                        <option value="63">Europe Trip</option>
                        <option value="147">excursion</option>
                      </select>
                    </div>

                    {/* Clear Button */}
                    <div className="transportation-details-col-lg">
                      <button
                        className="transportation-details-clear-btn"
                        id="clear"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>

                {/* Report Table */}
                <div
                  id="reportdiv"
                  className="transportation-details-table-responsive"
                >
                  <table
                    className="transportation-details-table"
                    id="billingreport"
                  >
                    <thead>
                      <tr>
                        <th className="transportation-details-th">SL NO</th>
                        <th className="transportation-details-th">Student Name</th>
                        <th className="transportation-details-th">Grade</th>
                        <th className="transportation-details-th">Matricule(ID)</th>
                        <th className="transportation-details-th">Parent Name</th>
                        <th className="transportation-details-th">Trip Type</th>
                        <th className="transportation-details-th">Vehicle</th>
                        <th className="transportation-details-th">Trip</th>
                        <th className="transportation-details-th">Bus Stop</th>
                        <th className="transportation-details-th">Distance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>testSTudent</td>
                        <td>1st A</td>
                        <td>9898545454</td>
                        <td>harisfather</td>
                        <td>pickup</td>
                        <td>Samsung Vehicle</td>
                        <td>Galaxy Scheduled Shift two</td>
                        <td>Mental Hospital Corner Mohanwadi</td>
                        <td>1590.76</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>testSTudent</td>
                        <td>1st A</td>
                        <td>9898545454</td>
                        <td>harisfather</td>
                        <td>drop</td>
                        <td>MH04AB04</td>
                        <td>Drop Trip</td>
                        <td>
                          Pune MB Shivaji Nagar fargson college behind.pandavnagar
                        </td>
                        <td>1582.99</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transportation_Details;
